import { ipcMain, BrowserWindow } from 'electron';

export const initializeWindowHandlers = (mainWindow: BrowserWindow) => {
    ipcMain.on('window-minimize', () => {
        const focusedWindow = BrowserWindow.getFocusedWindow();
        if (focusedWindow) focusedWindow.minimize();
    });

    ipcMain.on('window-toggle', () => {
        const focusedWindow = BrowserWindow.getFocusedWindow();
        if (focusedWindow) {
            if (focusedWindow.isMaximized()) {
                focusedWindow.unmaximize();
            } else {
                focusedWindow.maximize();
            }
        }
    });

    ipcMain.on('window-close', () => {
        mainWindow.hide();
    });

    ipcMain.on('window-drag', (event) => {
        const win = BrowserWindow.getFocusedWindow();
        if (win) {
            win.moveTop();
        }
    });
};